import { render, staticRenderFns } from "./PanelNonScheduledProducts.vue?vue&type=template&id=642bb1d5&lang=pug&"
import script from "./PanelNonScheduledProducts.vue?vue&type=script&lang=js&"
export * from "./PanelNonScheduledProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports